import React, { useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Topbar from "../Topbar/Topbar";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useRef } from "react";
import "./View_recurring.css";

export default function View_Recurring() {
  const [originalComplaint, setOriginalComplaint] = useState(null);

  const [taskData, setTaskData] = useState({});

  const [IsUpdateHistory, setIsUpdateHistory] = useState(false);
  const [IsDotBox, setIsDotBox] = useState(false);
  const locate = useLocation();
  const [isEditable, setIsEditable] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [names, setNames] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [approvePerson, setApprovePerson] = useState(null); // initially no one selected
  const [approvePersons, setApprovePersons] = useState([]); // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);

  const [selectedNames, setSelectedNames] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const Id = useSelector((state) => state.id);
  const [searchText, setSearchText] = useState("");

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const staffName = useSelector((state) => state.staffname);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredNames = names.filter((staff) =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    console.log("🟡 Submit button clicked");

    // Sync latest assignedTo & approvePerson
    const syncedTaskData = {
      ...taskData,
      assignedTo: selectedNames,
      approvePerson: approvePersons,
    };

    // ✅ Validation: Check required fields
    const {
      taskName,
      description,
      deadlineDays,
      taskPriority,

      weekdays,

      taskStatus,
    } = syncedTaskData;

    if (
      !taskName?.trim() ||
      !description?.trim() ||
      !deadlineDays ||
      !taskPriority?.trim() ||
      !taskStatus?.trim() ||
      selectedNames.length === 0 ||
      approvePersons.length === 0
    ) {
      Swal.fire(
        "Missing Fields",
        "Please fill all required fields.",
        "warning"
      );
      return;
    }

    // ✅ Check for no changes
    if (_.isEqual(syncedTaskData, originalComplaint)) {
      Swal.fire("No Changes", "No changes were made to update.", "info");
      return;
    }

    // ✅ Confirm popup
    const result = await Swal.fire({
      title: "Update the changes?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Update",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      console.log("⛔ User cancelled update");
      return;
    }

    // ✅ Prepare timestamp
    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();

    const updatedTaskDetails = {
      ...syncedTaskData,
      updatedBy: {
        staffname: staffName,
        _id: Id,
        time,
        date,
      },
    };

    try {
      const response = await axios.post(
        apiUrl + "update-recurring-task",
        updatedTaskDetails,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("✅ Update success:", response.data);
      Swal.fire("Updated!", "Task updated successfully", "success");

      setOriginalComplaint(_.cloneDeep(updatedTaskDetails));
      setIsEditMode(false);
      setIsEditable(false);
    } catch (error) {
      console.error("❌ Error updating task:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong!",
        "error"
      );
    }
  };
  // const handleSubmitAssignTask = async (e) => {
  //     e.preventDefault();

  //     Swal.fire({
  //       title: "Are you sure you want to create this task?",
  //       showCancelButton: true,
  //       confirmButtonText: "Submit",
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         try {
  //           const now = new Date();
  //           const day = String(now.getDate()).padStart(2, "0");
  //           const month = String(now.getMonth() + 1).padStart(2, "0");
  //           const year = now.getFullYear();
  //           const updatedDate = `${day}-${month}-${year}`;

  //           let hours = now.getHours();
  //           const minutes = String(now.getMinutes()).padStart(2, "0");
  //           const ampm = hours >= 12 ? "PM" : "AM";
  //           hours = hours % 12 || 12;
  //           const updatedTime = `${hours}:${minutes} ${ampm}`;

  //           const datas = {
  //             ...taskData,
  //             assignedBy: {
  //               staffName: staffName,
  //               id: Id
  //             },
  //             updatedDate,
  //             updatedTime,
  //             assignedTo: selectedNames,
  //             approvePerson: approvePersons,
  //           };

  //           // Required fields to check
  //           const requiredFields = [
  //             "taskName",
  //             "assignDateTime",

  //             "deadlineDays",
  //             "assignedTo",
  //             "approvePerson",
  //             "description",
  //           ];

  //           // Check for empty fields
  //           const emptyFields = requiredFields.filter(
  //             (field) => !datas[field] || (Array.isArray(datas[field]) && datas[field].length === 0)
  //           );

  //           if (emptyFields.length > 0) {
  //             Swal.fire({
  //               icon: "warning",
  //               title: "Incomplete Data",
  //               text: `Please fill all the fields:`,
  //             });
  //             return;
  //           }

  //           const response = await axios.post(
  //             apiUrl + "add-recurring-task",
  //             datas,
  //             { headers: { "Content-Type": "application/json" } }
  //           );

  //           Swal.fire({
  //             title: "Task Created Successfully!",
  //             icon: "success",
  //           }).then(() => {
  //             // navigate("/recurring");
  //           });
  //         } catch (error) {
  //           console.log("Error submitting data:", error.response?.data || error.message);
  //           Swal.fire({
  //             icon: "error",
  //             title: "Oops...",
  //             text: error.response?.data?.message || "Something went wrong!",
  //           });
  //         }
  //       }
  //     });
  //   };

  const toggleApproveDropdown = () => {
    setIsApproveOpen((prev) => !prev);
  };

  // const handleApproveCheckboxChange = (staff) => {
  //   setApprovePersons(prev => {
  //     const exists = prev.find(item => item._id === staff._id);
  //     if (exists) {
  //       // Remove staff
  //       return prev.filter(item => item._id !== staff._id);
  //     } else {
  //       // Add staff
  //       return [...prev, staff];
  //     }
  //   });
  // };
  const approvePersonText =
    approvePersons.length > 0
      ? approvePersons.map((item) => item.staffName).join(", ")
      : "Select Approve Persons";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        approveDropdownRef.current &&
        !approveDropdownRef.current.contains(event.target)
      ) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

 // Convert "06:39 PM" -> "18:39"
const convertTo24Hour = (time12h) => {
  if (!time12h) return "";
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");
  if (modifier === "PM" && hours !== "12") {
    hours = String(parseInt(hours, 10) + 12);
  }
  if (modifier === "AM" && hours === "12") {
    hours = "00";
  }
  return `${hours.padStart(2, "0")}:${minutes}`;
};

// When setting taskData from backend:



  const handleInputChange = (field, value) => {
    // if (field === 'time') {
    //   const [hours, minutes] = value.split(':');
    //   let hh = parseInt(hours, 10);
    //   const ampm = hh >= 12 ? 'PM' : 'AM';
    //   hh = hh % 12 || 12;
    //   const formattedTime = `${hh.toString().padStart(2, '0')}:${minutes} ${ampm}`;

    //   setTaskData(prev => ({
    //     ...prev,
    //     time: formattedTime, // Store as "hh:mm AM/PM"
    //     timeRaw: value        // Optional: keep raw value like "17:17" if needed
    //   }));
    // } else {
    setTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // }
  };

  const handleApproveCheckboxChange = (staff) => {
    setApprovePersons((prev) => {
      const isSelected = prev.some((item) => item._id === staff._id);
      if (isSelected) {
        return prev.filter((item) => item._id !== staff._id); // remove if unchecked
      } else {
        return [...prev, staff]; // add if checked
      }
    });
  };

  // Fetch staff whole data for dropdown
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setStaffData(res.data.message);

        console.log(res.data.message);
      });
  }, [apiUrl]);
  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setNames(res.data.message); // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  //   useEffect(() => {
  //   if (names && names.length > 0) {
  //     setApprovePersons(names); // Select all staff
  //   }
  // }, [names]);

  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // Checkbox change handler expects a staffName string
  const handleCheckboxChange = (staff) => {
    setSelectedNames((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  const handleCancelEdit = () => {
    setTaskData(_.cloneDeep(originalComplaint));
    setSelectedNames(originalComplaint.assignedTo || []);
    setApprovePersons(originalComplaint.approvePerson || []);
    setIsEditMode(false);
    setIsEditable(false);
  };

  // Display text: show staff names of selected IDs
  const displayText =
    selectedNames.length > 0
      ? selectedNames.map((item) => item.staffName).join(", ")
      : "Select names";

  useEffect(() => {
    if (locate.state?.id) {
      axios
        .post(apiUrl + "get-recurring-task", {
          _id: locate.state.id,
        })
        .then((res) => {
          const fetchedData = res.data.message;

          setTaskData(fetchedData);

          setTaskData((prev) => ({
  ...prev,
  time: convertTo24Hour(fetchedData.time)
}));
          setOriginalComplaint(_.cloneDeep(fetchedData)); // ✅ Deep clone for comparison
          setSelectedNames(fetchedData.assignedTo || []);
          setApprovePersons(fetchedData.approvePerson || []);
        })
        .catch((err) => console.error("Fetch failed", err));
    }
  }, [locate.state?.id]);

  console.log(taskData);

  return (
    <div>
      <Topbar />
      <Container className="mt-1">
        <Row className="ct-mainhead">
          <Col>
            <h3>Recurring Task</h3>
          </Col>

          {/* <Col className="text-end">
                        <button
    type="button"
    className="black-btn mx-3"
    onClick={handleCancelEdit}
  >
    Cancel
  </button>
                         <button
                           className="bluetask-btn px-4 text-white"
                           value="submit"
                           type="submit"
                           // onClick={gototaskPage}
                           onClick={handleSubmitAssignTask}
                         >
                           Submit
                         </button>
                       </Col> */}

          <Col className="text-end">
            {!isEditable ? (
              <button
                type="button"
                className="black-btn mx-3"
                onClick={() => setIsEditable(true)}
              >
                Edit
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="black-btn mx-3"
                  onClick={handleCancelEdit}
                >
                  Cancel
                </button>
                <button
                  className="bluetask-btn px-4 text-white"
                  type="submit"
                  onClick={handleSubmitAssignTask}
                >
                  Submit
                </button>
              </>
            )}
          </Col>
        </Row>
        <Row className="task-create-container">
          <div className="task-shadow">
            <form>
              <h6 className="create-task-head">Update Recurring Task</h6>
              <div className="create-task-head-1">
                <Row className="g-5">
                  <Col sm={12} md={6} style={{ marginTop: "68px" }}>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Task Name
                        </lable>
                        <br />
                        <input
                          sm={12}
                          type="text"
                          onChange={(e) =>
                            handleInputChange("taskName", e.target.value)
                          }
                          name="taskName"
                          className="form-input"
                          placeholder="Enter Task Name"
                          value={taskData.taskName}
                          required
                          style={{ textTransform: "capitalize" }}
                          disabled={!isEditable}
                        />
                      </Col>

                      <Col sm={12} md={6} className="text-start">
                        <label className="rowdown">Task Type</label>
                        <br />
                        <select
                          value={taskData.taskType}
                          onChange={(e) =>
                            handleInputChange("taskType", e.target.value)
                          }
                          className="dropbtn form-input-select overlay2"
                          required
                          disabled={!isEditable}
                        >
                          <option value="">Select</option>

                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                        </select>
                      </Col>

                      {/* Daily & Weekly & Monthly — Show Time */}

                      {/* Weekly — Show Weekday */}
                    </Row>
                    <Row>
                      <Col xs={12} md={6} className="text-start">
                        <label>Task Assign To</label>
                        <br />
                        <div
                          ref={dropdownRef}
                          style={{ position: "relative", width: "85%" }}
                        >
                          <div
                            onClick={toggleDropdown}
                            style={{
                              padding: "10px",
                              border: "2px solid #a7a7a7",
                              borderRadius: "4px",
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {displayText}
                            </span>
                            <span>{isOpen ? "▲" : "▼"}</span>
                          </div>

                          {isOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                marginTop: "5px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                zIndex: 1000,
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {/* 🔍 Search Input */}
                              <input
                                type="text"
                                placeholder="Search staff..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{
                                  width: "95%",
                                  margin: "10px auto",
                                  display: "block",
                                  padding: "8px",
                                  borderRadius: "4px",
                                  border: "1px solid #ccc",
                                }}
                              />

                              {/* Filtered Staff List */}
                              {staffData
                                .filter((staff) =>
                                  [
                                    "Admin",
                                    "Super Admin",
                                    "Network Admin",
                                    "Accounts Admin",
                                    "Marketing Admin",
                                    "Network Engineer",
                                    "Marketing/Fiber",
                                    "Accountant",
                                    "Tele Calling",
                                  ].includes(staff.designation)
                                )
                                .filter((staff) =>
                                  staff.staffName
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                ).length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px",
                                    color: "#888",
                                    textAlign: "center",
                                  }}
                                >
                                  No Staffs found
                                </div>
                              ) : (
                                staffData
                                  .filter((staff) =>
                                    [
                                      "Admin",
                                      "Super Admin",
                                      "Network Admin",
                                      "Accounts Admin",
                                      "Marketing Admin",
                                      "Network Engineer",
                                      "Marketing/Fiber",
                                      "Accountant",
                                      "Tele Calling",
                                    ].includes(staff.designation)
                                  )
                                  .filter((staff) =>
                                    staff.staffName
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  )
                                  .map((staff) => (
                                    <label
                                      key={staff._id}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectedNames.some(
                                          (item) => item._id === staff._id
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(staff)
                                        }
                                        style={{ marginRight: "10px" }}
                                        required
                                      />
                                      {staff.staffName || "(No Name)"}
                                    </label>
                                  ))
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs={12} md={6} className="text-start">
                        <label>Approve Person</label>
                        <br />
                        <div
                          ref={approveDropdownRef}
                          style={{
                            position: "relative",
                            width: "85%",
                            marginTop: "15px",
                          }}
                        >
                          <div
                            onClick={toggleApproveDropdown}
                            style={{
                              padding: "10px",
                              border: "2px solid #a7a7a7",
                              borderRadius: "4px",
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "-5px",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {approvePersonText}
                            </span>
                            <span>{isApproveOpen ? "▲" : "▼"}</span>
                          </div>

                          {isApproveOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                marginTop: "5px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                zIndex: 1000,
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {/* 🔍 Search Input */}
                              <input
                                type="text"
                                placeholder="Search staff..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "8px 10px",
                                  borderBottom: "1px solid #ccc",
                                  boxSizing: "border-box",
                                  outline: "none",
                                  border: "none",
                                }}
                              />

                              {/* 🧑‍💼 Filtered Staff List */}
                              {filteredNames.length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px",
                                    color: "#888",
                                    textAlign: "center",
                                  }}
                                >
                                  No staff found
                                </div>
                              ) : (
                                filteredNames.map((staff) => (
                                  <label
                                    key={staff._id}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "10px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #eee",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      required
                                      checked={approvePersons.some(
                                        (item) => item._id === staff._id
                                      )}
                                      onChange={() =>
                                        handleApproveCheckboxChange(staff)
                                      }
                                      style={{ marginRight: "10px" }}
                                    />
                                    {staff.staffName || "(No Name)"}
                                  </label>
                                ))
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs={12} md={12} className="text-start mt-4">
                        <lable>Description</lable>
                        <br />
                        <textarea
                          type="text"
                          onChange={(e) =>
                            handleInputChange("description", e.target.value)
                          }
                          style={{
                            textTransform: "capitalize",
                            resize: "none",
                          }}
                          className="form-input inputfield-assign "
                          placeholder="Enter Notes "
                          required
                          disabled={!isEditable}
                          value={taskData.description}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      {(taskData.taskType === "Daily" ||
                        taskData.taskType === "Weekly" ||
                        taskData.taskType === "Monthly") && (
                        <Col sm={12} md={6} className="text-start mt-3">
                          <label>Time</label>
                          <br />
                          <input
                            type="time"
                            className="form-input"
                            value={taskData.time}
                            onChange={(e) =>
                              handleInputChange("time", e.target.value)
                            }
                            required
                            disabled={!isEditable}
                          />
                        </Col>
                      )}
                      {/* <Col sm={12} md={6} className="text-start">
                                                          <lable sm={12} className="rowdown ">
                                                            Task Type
                                                          </lable>
                                                          <br />
                                                          <select
                                                            onChange={(e) => handleInputChange('taskType', e.target.value)}
                                                            class="dropbtn form-input-select overlay2"
                                                            required
                                  
                                                          >
                                                            <option
                                  
                                  
                                                              value="Once"
                                                            >
                                                              Once
                                                            </option>
                                                            <option value="Daily">
                                                              Daily
                                                            </option>
                                                            <option value="weekly">
                                                              Weekly
                                                            </option>
                                                            <option value="Monthy">
                                                              Monthly
                                                            </option>
                                                            <option value="Custom">
                                                              Custom
                                                            </option>
                                                          </select>
                                                        </Col> */}

                      {taskData.taskType === "Weekly" && (
                        <Col sm={12} md={6} className="text-start mt-3">
                          <label>Weekday</label>
                          <br />
                          <select
                            className="dropbtn form-input-select"
                            value={taskData.weekday}
                            onChange={(e) =>
                              handleInputChange("weekday", e.target.value)
                            }
                            required
                            disabled={!isEditable}
                          >
                            <option value="">Select Weekday</option>
                            {weekdays.map((day) => (
                              <option key={day} value={day}>
                                {day}
                              </option>
                            ))}
                          </select>
                        </Col>
                      )}

                      {/* Monthly — Show Date */}
                      {taskData.taskType === "Monthly" && (
                        <Col sm={12} md={6} className="text-start mt-3">
                          <label>Date</label>
                          <br />
                          <select
                            disabled={!isEditable}
                            required
                            onChange={(e) =>
                              handleInputChange("date", e.target.value)
                            }
                            className="dropbtn form-input-select overlay2"
                            value={taskData.date} // Optional: to control selected value
                          >
                            <option value="">Select Date </option>
                            {Array.from({ length: 31 }, (_, i) => {
                              const value = String(i + 1).padStart(2, "0");
                              return (
                                <option key={value} value={value}>
                                  {value}
                                </option>
                              );
                            })}
                          </select>
                        </Col>
                      )}
                    </Row>
                    <br />
                    <Row>
                      {/* <Col sm={12} md={6} className="text-start">
                                                          <lable sm={12} className="rowdown ">
                                                            Deadline Date
                                                          </lable>
                                                          <br />
                                                          <input
                                                            type="date"
                                                            onChange={(e) => handleInputChange('deadlineDays', e.target.value)}
                                                            className="form-input overlay2"
                                                            placeholder=""
                                                            required
                                                            style={{ width: "85%" }}
                                                          //  min={new Date().toISOString().split("T")[0]}
                                  
                                                          />
                                                        </Col> */}

                      <Col sm={12} md={6} className="text-start">
                        <label className="rowdown">Deadline Days</label>
                        <br />

                        <select
                          disabled={!isEditable}
                          required
                          onChange={(e) =>
                            handleInputChange("deadlineDays", e.target.value)
                          }
                          className="dropbtn form-input-select overlay2"
                          value={taskData.deadlineDays} // Optional: to control selected value
                        >
                          {Array.from({ length: 10 }, (_, i) => {
                            const value = String(i + 1).padStart(2, "0");
                            return (
                              <option key={value} value={value}>
                                {value}
                              </option>
                            );
                          })}
                        </select>

                        {/* <input
                               type="text"
                               value={taskData.deadlineDays || ""}
                               onChange={(e) => handleInputChange('deadlineDays', e.target.value)}
                               className="form-input overlay2"
                               required
                               style={{ width: "85%" }}
                               // min={new Date().toISOString().split("T")[0]} // optional min date
                             /> */}
                      </Col>

                      {/* <Col xs={12} md={6} className="text-start">
                                                          <lable> Deadline Time</lable>
                                                          <br />
                                                          <input
                                                            required
                                                            type="time"
                                                            onChange={(e) => handleInputChange('time', e.target.value)}
                                                            className="form-input overlay2"
                                                            placeholder=""
                                                          />
                                                        </Col> */}

                      {/* <Col xs={12} md={6} className="text-start">
                             <label>Deadline Time</label>
                             <br />
                             <input
                             type="text"
                             value={taskData.time || ""}
                             onChange={(e) => handleInputChange('time', e.target.value)}
                             placeholder="hh:mm AM/PM"
                             className="form-input"
                             
                           />
                           
                           </Col> */}

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Task Priority</lable>
                        <br />
                        <select
                          required
                          disabled={!isEditable}
                          onChange={(e) =>
                            handleInputChange("taskPriority", e.target.value)
                          }
                          class="dropbtn form-input-select overlay2"
                        >
                          <option value="Low">Low</option>
                          <option value="High">High</option>
                          <option value="Immediate">Immediate</option>
                        </select>
                      </Col>

                      {/* <Col sm={12} md={6} className="text-start">
                                                          <lable className="rowdown">Task Status</lable>
                                                          <br />
                                  
                                                          <input
                                                            sm={12}
                                                            type="string"
                                                            onChange={(e) => setTaskDeadline(e.target.value)}
                                                            className="openTask-form"
                                                            placeholder="Open"
                                                            // onClick={() => setIsOpenTask(true)}
                                                            onClick={showOpenTask}
                                                          />
                                  
                                                          {IsOpenTask && (
                                                            <div className="overlay1-open">
                                                              <div className="modal1-open">
                                                                <Container>
                                                                  <button
                                                                    className="close-btn1"
                                                                    onClick={() => setIsOpenTask(false)}
                                                                  >
                                                                    <span style={{ fontSize: "20px" }}>
                                                                      &times;
                                                                    </span>
                                                                  </button>
                                  
                                                                  <div className="open-button">
                                                                    <h5>Open</h5>
                                                                  </div>
                                  
                                                                  <textarea
                                                                    style={{
                                                                      textTransform: "capitalize",
                                                                      resize: "none",
                                                                    }}
                                                                    placeholder="Enter Description"
                                                                    className="open-textbox"
                                                                  />
                                                                  <div className="upload-section">
                                                                    <label className="upload-btn">
                                                                      <FiUpload className="upload-icon" />
                                                                      Upload Image
                                                                      <input
                                                                        type="file"
                                                                        accept="image/*"
                                                                        onChange={handleFileChange}
                                                                        hidden
                                                                      />
                                                                    </label>
                                                                    {selectedFile && (
                                                                      <p className="file-name">
                                                                        {selectedFile.name}
                                                                      </p>
                                                                    )}
                                                                  </div>
                                  
                                                                  <Row>
                                                                    <Col className="uploadbtn-install">
                                                                      <button
                                                                        type="button"
                                                                        className="blue-btn"
                                                                        onClick={showUploadTask}
                                                                      >
                                                                        Upload
                                                                      </button>
                                                                    </Col>
                                                                  </Row>
                                                                </Container>
                                                              </div>
                                                            </div>
                                                          )}
                                                        </Col> */}

                      <Col xs={12} md={6} className="text-start mt-3">
                        <lable>Task Status </lable>
                        <br />
                        <input
                          disabled={!isEditable}
                          type="text"
                          onChange={(e) =>
                            handleInputChange("taskStatus", e.target.value)
                          }
                          style={{
                            textTransform: "capitalize",
                            textAlign: "center",
                            backgroundColor: "#fbdc6e",
                            color: "rgb(94, 94, 14)",
                            cursor: "pointer",
                          }}
                          className="form-input "
                          value={taskData.taskStatus}
                          readOnly
                        />
                      </Col>
                      <Col xs={12} md={6} className="text-start mt-3">
                        <label>Recurring Status</label>
                        <br />
                        <select
                          disabled={!isEditable}
                          name="recurringStatus"
                          value={taskData.recurringStatus || ""}
                          onChange={(e) =>
                            setTaskData((prev) => ({
                              ...prev,
                              recurringStatus: e.target.value,
                            }))
                          }
                          className={`form-input-select dropbtn ${
                            taskData.recurringStatus === "Active"
                              ? "recurring-active"
                              : taskData.recurringStatus === "InActive"
                              ? "recurring-inactive"
                              : ""
                          }`}
                        >
                          <option value="Active" className="option-active">
                            Active
                          </option>
                          <option value="InActive" className="option-inactive">
                            InActive
                          </option>
                        </select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </form>
          </div>
        </Row>

        {IsUpdateHistory && (
          <div className="row historybox mt-5">
            <div className="col">
              <div className="historyLeft">
                <p>
                  K. Saravanan&emsp;<span>2h</span>
                </p>
                <p className="textOrange">Task / Open</p>

                <p
                  className="dotBoxPos"
                  onClick={() => {
                    setIsDotBox(true);
                  }}
                >
                  <span>&#8942;</span>
                  {IsDotBox && (
                    <div className="dotBox">
                      <div className="dorBox1">
                        <p>Approved</p>
                        <p>Delete</p>
                      </div>
                    </div>
                  )}
                </p>
              </div>
            </div>
            <div className="col uhistory px-0">
              <div className="updateHistory">
                <p className="updateHistory_1">
                  <b>Update History</b>
                </p>
              </div>
              <div className="row px-5">
                <div className="historyData">
                  <p>12/12/2024 - 12.30 PM</p>
                  <p>Saravanan</p>
                  <p style={{ color: "#866A04", fontWeight: "bold" }}>Open</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}
